import { FETCH_MATCHES } from './actionTypes'

export type MatchesState = {
  list: any[]
  leagueId: string | null
  sportId: string | null
}

const initialState = {
  list: [],
  leagueId: null,
  sportId: null,
}

export const matchesReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_MATCHES:
      return {
        ...state,
        ...action.payload,
      }

    default:
      return state
  }
}
